import { createSelector } from 'reselect';

import type { SliceStateFromReducer } from 'shared/types';

import { isHTML } from '../lib/isHTML';

import type { metadataSlice } from './metadata.slice';

type TMetadataState = SliceStateFromReducer<typeof metadataSlice>;

export const metadataSelector = (state: TMetadataState) => state.metadata;

export const seoBlocksSelector = createSelector(metadataSelector, (metadata) => metadata?.contentBlocks?.find(isHTML));
export const seoH1Selector = createSelector(metadataSelector, (metadata) => metadata?.heading);
export const seoSubHeadingSelector = createSelector(metadataSelector, (metadata) => metadata?.subHeading);
export const seoPrefooterSelector = createSelector(metadataSelector, (metadata) => metadata?.prefooter);

export const hasAnySeoDataSelector = createSelector(metadataSelector, (metadata) => {
  if (!metadata) {
    return false;
  }

  const hasSeoBreadcrumbs = !!metadata?.breadcrumbs?.length;
  const hasPrefooter = !!metadata?.prefooter?.length;
  const hasSeoBlocks = !!metadata?.text;

  return hasSeoBreadcrumbs || hasPrefooter || hasSeoBlocks;
});
